import { useDispatch, useSelector } from "react-redux";
import { downloadGuaranteesReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useGuaranteesReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.guarantees.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadGuaranteesReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
